import request from '@/config/axios'

/** A 端商家主体 SSOT 页路径（与 system_menu path 一致） */
export const MERCHANT_ENTITY_ADMIN_PATH = '/merchant-ops/entity'

export interface MerchantEntityItem {
  id: number
  name: string
  contactPhone?: string
  status?: string
  loginUsername?: string
  moduleIds?: string[]
}

export type MerchantModuleOpenScene =
  'ADMIN_INITIAL' | 'ADMIN_APPEND' | 'APP_ONBOARDING' | 'SYSTEM_RETRY'

export interface MerchantModuleOption {
  moduleId: string
  moduleKey: string
  moduleName: string
  frontendKey: string
  sort: number
  requiresAccount: boolean
  alreadyOpened: boolean
  configSchema?: unknown
}

export const createMerchant = (data: {
  name: string
  licenseNo?: string
  licenseUrl?: string
  legalPerson?: string
  contactPhone: string
  contactEmail?: string
  loginUsername: string
  loginPassword: string
  initialModuleIds?: string[]
  moduleParams?: Record<string, Record<string, unknown>>
}) =>
  request.post<{ merchantId: number; accountId: number; loginUsername: string }>({
    url: '/merchant/workbench/create-merchant',
    data
  })

export const openModule = (data: {
  merchantId: number
  moduleId: string
  scene?: MerchantModuleOpenScene
  params?: Record<string, unknown>
}) => request.post({ url: '/merchant/workbench/open-module', data })

export const getMerchantModuleOptions = (scene: MerchantModuleOpenScene, merchantId?: number) =>
  request.get<MerchantModuleOption[]>({
    url: '/merchant/module-catalog/options',
    params: { scene, ...(merchantId != null ? { merchantId } : {}) }
  })

export const listMerchants = () =>
  request.get<MerchantEntityItem[]>({ url: '/merchant/workbench/entity/list' })

export const backfillEntitlements = () =>
  request.post<number>({ url: '/merchant/workbench/backfill-entitlements' })

/** 跳转商家主体页（L0 开通 / L1 开模块） */
export const merchantEntityLink = (opts?: {
  action?: 'create' | 'open'
  module?: string
  merchantId?: number
}) => {
  const q = new URLSearchParams()
  if (opts?.action) q.set('action', opts.action)
  if (opts?.module) q.set('module', opts.module)
  if (opts?.merchantId != null) q.set('merchantId', String(opts.merchantId))
  const qs = q.toString()
  return qs ? `${MERCHANT_ENTITY_ADMIN_PATH}?${qs}` : MERCHANT_ENTITY_ADMIN_PATH
}
